import { ORG_CONFIG } from "../org/config";
import { ORG_IDS, OrgKey } from "../org/config";

export function getOrgKey(orgId: number): OrgKey {
  if (orgId === ORG_IDS.BARNES) {
    return "barnes";
  } else if (orgId === ORG_IDS.PENN) {
    return "penn";
  } else {
    return "neutral";
  }
}

export function getOrgConfig(orgId: number) {
  const key = getOrgKey(orgId);
  return ORG_CONFIG[key];
}
